import { cn } from 'noddi-ui-common';
import { formatCurrencyAmount, getStruckThroughCatalogPrice } from 'noddi-util';
import { getCatalogPayableText, type PayableTextProps } from './getCatalogPayableText';

type Props = PayableTextProps & {
  align?: 'start' | 'end';
  payableClassName?: string;
  /** `inline` puts the struck list price on the same baseline as the payable one, after it. */
  layout?: 'stack' | 'inline';
};

export const CatalogPrice = ({
  payable,
  original,
  decimals = 0,
  align = 'start',
  freeLabel,
  hideWhenZero,
  payableClassName,
  layout = 'stack'
}: Props) => {
  const payableText = getCatalogPayableText({ payable, original, decimals, freeLabel, hideWhenZero });
  if (payableText == null) {
    return null;
  }

  const struck = getStruckThroughCatalogPrice({ payable, original });

  if (struck == null) {
    return <span className={payableClassName}>{payableText}</span>;
  }

  const struckText = formatCurrencyAmount({ money: struck, decimals });

  if (layout === 'inline') {
    return (
      <span className='flex flex-wrap items-baseline gap-2'>
        <span className={cn('font-semibold text-foreground', payableClassName)}>{payableText}</span>
        <span className='text-muted-foreground line-through'>{struckText}</span>
      </span>
    );
  }

  return (
    <span className={cn('flex flex-col', align === 'end' && 'items-end gap-0.5')}>
      <span className='text-muted-foreground line-through'>{struckText}</span>
      <span className={cn('font-semibold text-foreground', payableClassName)}>{payableText}</span>
    </span>
  );
};
